export function listingHref(
  listing: { slug?: string | null; publicIdentifier?: string | null; _id: string },
  requestedQuantity?: number,
): string {
  const path = `/listing/${listing.slug ?? listing.publicIdentifier ?? listing._id}`;
  return requestedQuantity !== undefined &&
    Number.isSafeInteger(requestedQuantity) && requestedQuantity > 1
    ? `${path}?qty=${requestedQuantity}`
    : path;
}
